import axios from 'axios'
import router from './router/index.js'
import vue from './utils/bus.js'
import cookie from "./utils/cookie.js";
import config from './config.json'
import api from '@/common/api.js'

//请求初始化配置
axios.defaults.withCredentials  = true;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.baseURL = config.api_url;
// axios.defaults.baseURL='http://192.168.0.102:8081/resources/request';
// 添加请求拦截器
axios.interceptors.request.use(function(config) {
    let obj = {}
    if (!config['data']) {
        config['data'] = obj
    }
    // config['data'].tenantId='hsfscz';
    let params = config.data;
    // console.log(api.login.sessionId)
    let token = cookie.getCookie(api.login.sessionId);
    if (token != null) {
        config.headers.Authorization = token
    }
    return config;
  },
  function(error) {
    // console.log('请求错误：', error)
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
    // 对响应数据做点什么
    // return response;
    if (response.data.errorCode == 401) {
            cookie.delCookie(api.login.sessionId);
            router.replace({
                path: "/",
                redirect: "/"
            });
            return false;
    }
    let res = response.data;
    return res;

}, function(error) {
  console.log('响应错误：', error)
  // 对响应错误做点什么
  if(error.response.status == 400 || error.response.status == 500){
    if(error.response.data.errorCode == '-1'){
      vue.$message.error(error.response.data.errorMsg)
    }
  }
  return Promise.reject(error);
});
export default axios;



// WEBPACK FOOTER //
// ./src/http.js